module.exports = __webpack_public_path__ + "static/media/61850trans3.2acbae97.png";